import { useMemo } from 'react';
import { useQueryState } from '@ywwwtseng/react-kit';
import type { SelectToken } from '@/types';

export function useTokens(
  networks: string[] = ['bsc', 'solana', 'ethereum', 'ton']
) {
  const tokens = useQueryState<SelectToken[]>('tokens');

  return useMemo(() => {
    return tokens?.filter(
      (token) => !token.network || networks.includes(token.network)
    );
    // if (networks) {
    //   return tokens?.filter(
    //     (token) => !token.network || networks.includes(token.network)
    //   );
    // } else {
    //   return tokens;
    // }
  }, [tokens, networks]);
}
